import { Modal } from 'antd';
import AssetListModalV from 'pages/Asset/AssetListModalV3';
import React from 'react';
import { AssetSelectedType } from './AssetSelect';

export type AssetSearchModalProps = {
  visible: boolean;
  onCancel: () => void;
  setAsset?: (Asset: AssetSelectedType) => void;
  ctref?:string
  phase?:any
};

const AssetSearchModal = ({
  ctref,
  onCancel,
  visible,
  setAsset,
  phase
}: AssetSearchModalProps) => {
  return (
    <Modal open={visible} onCancel={onCancel} width={1200} destroyOnClose>
      <AssetListModalV onSelect={setAsset} phase={phase??"PROPOSAL"} ctref={ctref}/>
    </Modal>
  );
};

export default AssetSearchModal;
